export default {
    createNewDepartment: 'สร้างแผนกใหม่',
    departmentName: 'ชื่อเเผนก',
    description: 'คำอธิบาย',
    managerInformation: 'ผู้จัดการข้อมูล',
    fullName: 'ชื่อ - นามสกุล',
    eamilAddress: 'อีเมล์',
    phoneNumber: 'เบอร์โทรศัพท์',
    firstPermissionLevel: 'ผู้อนุมัติระดับที่ 1',
    secondPermissionLevel: 'ผู้อนุมัติระดับที่ 2',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    incorrectPhoneNubmer: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    thisFieldIsExceededCharacters: 'ข้อความเกิน 255 ตัวอักษร',
    save: 'บันทึก',
    emailIsRequired: 'กรุณากรอกอีเมล์',
    invalidEmailFormat: 'รูปเเบบอีเมล์ไม่ถูกต้อง',
    emailIsExceededCharacters: 'อีเมล์เกิน 255 ตัวอักษร',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด',
    editDepartment: 'เเก้ไขเเผนก',
    departmentIsCreated: 'แผนกถูกสร้างแล้ว',
    departmentIsUpdated: 'เเผนกถูกอัปเดตแล้ว'
}
